export default __webpack_public_path__ + "static/force-usa_small-image_4-52e0b5ca33256b8bec15516c90ef0c5c.webp";